import { SVGProps, memo } from 'react';
import { useTheme } from '@mui/material/styles';

const DropFilesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 9V16H2.5V9H0.5V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V9H16.5ZM10.5 9.67L13.09 7.09L14.5 8.5L9.5 13.5L4.5 8.5L5.91 7.09L8.5 9.67V0H10.5V9.67Z" fill={props.color || "black"}/>
    </svg>
  );
};

export default memo(DropFilesIcon);
